import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

import firstPlaceSrc from "./icons/first-place.svg";
import secondPlaceSrc from "./icons/second-place.svg";
import thirdPlaceSrc from "./icons/third-place.svg";

export const createRankingStyles = ({
  spacing,
  typography,
  borderRadius,
}: Theme) => {
  return {
    root: css({
      margin: `${spacing(2)} auto`,
      color: grey[900],
    }),
    user: css({
      minHeight: 60,
      columnGap: spacing(2),
      width: "100%",
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: "35px 1fr",
      borderRadius: borderRadius.medium,
      padding: spacing([1.5, 2, 1.5, 1.5]),
    }),
    place: css({
      height: "100%",
      display: "grid",
      placeItems: "center",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      '&[data-place="1"]': {
        backgroundImage: `url(${firstPlaceSrc})`,
      },
      '&[data-place="2"]': {
        backgroundImage: `url(${secondPlaceSrc})`,
      },
      '&[data-place="3"]': {
        backgroundImage: `url(${thirdPlaceSrc})`,
      },
    }),
    currentUser: css({
      background: grey[100],
    }),
    personDetails: css({
      display: "flex",
      justifyContent: "space-between",
      lineHeight: typography.fontSize.large,
    }),
    fullName: css({
      wordBreak: "break-word",
    }),
    points: css({
      marginLeft: spacing(0.5),
      fontWeight: typography.fontWeight.bold,
    }),
  };
};
